import React from 'react';

import Box from '@rover/kibble/core/Box';

import type { AvatarSize, StyleProps } from '../Avatar';
import Avatar, { getSize } from '../Avatar';

export const MAX_IMAGES = 5;

export type Props = {
  imageUrls: string[];
  disabled?: boolean;
} & StyleProps;

const StackedAvatar = ({ imageUrls, ...props }: Props): JSX.Element | null => {
  const size: AvatarSize = getSize(props.size);
  const reverseImages = imageUrls
    .filter((url) => url !== 'undefined')
    .slice(0, MAX_IMAGES)
    .reverse();
  const numImages = reverseImages.length;
  if (numImages === 0) return null;

  const fullWidth = numImages === 1 ? size.diameter : size.diameter * 1.5;
  const maxLeft = fullWidth - size.diameter;

  const avatars = reverseImages.map((imageUrl, index) => {
    const left = numImages === 1 ? 0 : maxLeft - (index * maxLeft) / (numImages - 1);

    return (
      <Box key={index} position="absolute" left={`${left}px`}>
        <Avatar
          imageUrl={imageUrl}
          {...props}
          borderRadius={999}
          objectFit="cover"
          borderWidth={2}
          borderColor="white"
          showBorder
        />
      </Box>
    );
  });

  return (
    <Box
      flexDirection="row"
      flexShrink="0"
      position="relative"
      width={`${fullWidth}px`}
      height={`${size.diameter}px`}
      data-testid="stackedAvatarContainer"
    >
      {avatars}
    </Box>
  );
};

export default StackedAvatar;
